<template>
    <div class="comvisualMap chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.visualMap.show" @change="getRender">是否展示视觉映射组件</el-checkbox>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">类型</span>
            <el-select v-model="config.visualMap.type" placeholder="请选择组件类型"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in visualMapList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig" v-if="config.visualMap.type=='piecewise'">
            <span class="span_til">分成几段</span>
            <el-input v-model="config.visualMap.splitNumber" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig checkViewConfig" >
            <el-checkbox v-model="config.visualMap.showLabel" @change="getRender">是否显示文本标签</el-checkbox>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.visualMap.inverse" @change="getRender">是否反转组件</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig" v-if="config.visualMap.type=='piecewise' && config.visualMap.showpieces==false" >
            <span class="span_til">最小值</span>
            <el-input v-model="config.visualMap.min" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig" v-if="config.visualMap.type=='piecewise' && config.visualMap.showpieces==false">
            <span class="span_til">最大值</span>
            <el-input v-model="config.visualMap.max" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.visualMap.showpieces" @change="getRender">是否自定义组件</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig piecesstyle" :class="{ piecesList: $store.state.dpType !==0 }" v-for="(item,index) in config.visualMap.pieces" :key="index" v-if="config.visualMap.showpieces" >
            <div class="itemtitle clearFloat" >
                <span class="span_til" @click="showItem(index)">
                     <i :class="item.iconData"></i>第<span>{{index+1}}</span>组
                </span>
                <FSvg title="加" :color="'#41ac46'" IconSize="16" @click.native="getPieces('add')" v-if="index==config.visualMap.pieces.length-1"></FSvg>
                <FSvg title="删除" :color="'#bf6a4e'" IconSize="18" @click.native="getPieces('del',index)" v-if="config.visualMap.pieces.length>1"></FSvg>
            </div>
            <div class="interval clearFloat" v-if="item.show">
                <span class="span_til">
                   区间
                </span>
                <el-input v-model="item.min" @change="getRender" type="number" placeholder="最小值"></el-input>
                <el-input v-model="item.max" @change="getRender" type="number" placeholder="最大值"></el-input>
            </div>
            <div class=" colViewConfig clearFloat" v-if="item.show">
                <span class="span_til">颜色</span>
                <el-color-picker v-model="item.color" show-alpha @change="getRender"></el-color-picker>
            </div>
            <div class="labeltext clearFloat" v-if="item.show">
                <span class="span_til">文本</span>
                <el-input v-model="item.label" @change="getRender"></el-input>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     @author hjj
     @date 2020/6/8 5:22 下午
     */
    export default {
        name: 'comLegend',
        components: {},
        props: {
            name: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                visualMapList: [
                    {value: 'continuous', label: '连续型'},
                    {value: 'piecewise', label: '分段型'},
                ],

            }
        },
        computed: {
            config() {
                if (this.$store.state.dpType === 0) {
                    return this.$store.state.viewDP.chart.setting.params;
                }else{
                    return this.$store.state.designer.chart.setting.params;
                }
            },
            colorList() {
                let list = [];
                for (let i in colorList) {
                    list.push({
                        name: i,
                        color: colorList[i]
                    });
                }
                return list;
            },
        },
        methods: {
            getRender() {
                if (this.$store.state.dpType === 0) {
                    this.$store.dispatch('viewDPRender');
                }else if (this.$store.state.dpType === 1) {
                    this.$store.dispatch('screenRender');
                }
            },
            getPieces(type, index){
                if (type === 'add') {
                    this.config.visualMap.pieces.push({min:'', max: '', label: '',color:'',show:true,iconData:'el-icon-arrow-down'});
                } else if (type === 'del') {
                    this.config.visualMap.pieces.splice(index, 1);
                }
            },
            showItem(index){
                this.config.visualMap.pieces[index].show=!this.config.visualMap.pieces[index].show;
                if(this.config.visualMap.pieces[index].show){
                    this.config.visualMap.pieces[index].iconData = 'el-icon-arrow-down';
                }else{
                    this.config.visualMap.pieces[index].iconData = 'el-icon-arrow-up';
                }
            },
        },
        watch:{
            "config.visualMap.showpieces"(){
                if(this.config.visualMap.showpieces){
                    this.config.visualMap.pieces=[{min:'', max:'', label: '',color:'',show:true,iconData:'el-icon-arrow-down'}];
                }
            }
        },
        mounted() {
            //筛选 字符串 条件筛选


        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .comvisualMap {
        padding: 40px 0 0;
        .for_tjFil {
            width: 100%;
            max-height: 330px;
            overflow-x: hidden;
            overflow-y: auto;
            padding: 15px 15px;

            .tjFilCoDiv {
                width: 100%;
                white-space: nowrap;
                height: 35px;
                margin-bottom: 10px;
                display: inline-block;

                > span {
                    width: 130px;
                    display: inline-block;
                    line-height: 35px;
                    margin-right: 15px;
                    float: left;
                    text-align: left;
                    .text_oneLine;
                }

                .el-select {
                    width: 120px;
                    float: left;
                    margin-right: 15px;

                    .el-input {
                        width: 100% !important;
                    }

                    .el-input__inner {
                        height: 35px;
                        line-height: 35px;
                    }

                    .el-input__icon {
                        line-height: 35px;
                    }
                }

                .el-input {
                    width: calc(100% - 350px);
                    margin-right: 15px;
                    float: left;

                    .el-input__inner {
                        height: 35px;
                        line-height: 35px;
                    }
                }

                .qj_item {
                    width: calc((100% - 350px - 15px) / 2);
                    margin-right: 15px;
                }

                .FSvg {
                    float: left;
                    margin-right: 15px;
                    .com_middle;
                }

                .FSvg:last-child {
                    margin-right: 0;
                }
            }

            .tjFilCoDiv:last-child {
                margin-bottom: 0;
            }
        }
        .piecesstyle{
            .itemtitle{
                padding:0;
                text-align: right;
                background: #f5f5f5;
                .span_til{
                    width: 30%;
                    >i{
                        padding-right:6px;
                    }
                    text-align: left;
                }
                .FSvg{
                    padding-right: 10px;
                }
            }
            >div{
                padding:0 5px;
                .span_til{
                    width: 15%;
                }
            }
            .labeltext{
                .el-input{
                    width: 75%;
                }
            }
            .interval{
                .el-input{
                    min-width: 50px;
                    margin-right:6px;
                }
            }

        }
        .piecesList{
            .itemtitle {
                background: hsla(178.51851852, 81%, 39.21568627%, 0.4);
            }
        }
    }

</style>